import { ExtendedStoreCart } from "types/global";
import DrawerCustom from "../drawer-custom";
import ContentCart from "./content";
import FooterCart from "./footer";

type Props = {
  isOpen: boolean;
  cart: ExtendedStoreCart | null;
  onClose: () => void;
};

function CartDrawer({ isOpen, cart, onClose }: Props) {
  const totalItems = cart?.items?.reduce((acc, item) => acc + item.quantity, 0) || 0;

  return (
    <DrawerCustom
      isOpen={isOpen}
      onClose={onClose}
      header={<h2 className="text-primary-color text-lg font-semibold">Giỏ hàng ({totalItems} sản phẩm)</h2>}
      content={<ContentCart cart={cart} />}
      footer={<FooterCart cart={cart} onClose={onClose} />}
    />
  );
}

export default CartDrawer;
